// extracted by mini-css-extract-plugin
export default {"hr":"style_hr__q1S0K"};